var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductSerialNumbers',{on:{"select-product-serial-number":_vm.openProductSerialNumber}})
}
var staticRenderFns = []

export { render, staticRenderFns }